export const COUNTRIES = [
  { code: "ALL", name: "All Locations" },
  { code: "CH", name: "Switzerland" },
  { code: "US", name: "United States" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "GB", name: "United Kingdom" },
  { code: "IT", name: "Italy" },
  { code: "ES", name: "Spain" },
  { code: "NL", name: "Netherlands" },
  { code: "AT", name: "Austria" },
  { code: "BE", name: "Belgium" },
  { code: "AU", name: "Australia" },
  { code: "CA", name: "Canada" },
  { code: "JP", name: "Japan" },
  { code: "BR", name: "Brazil" },
  { code: "IN", name: "India" },
];

export const AD_FORMATS = [
  { value: "ALL", label: "All Formats" },
  { value: "TEXT", label: "Text Ads" },
  { value: "IMAGE", label: "Image Ads" },
  { value: "VIDEO", label: "Video Ads" },
];
